module.exports = __webpack_public_path__ + "img/b-cicle-out.d1f28888.png";